import { render, staticRenderFns } from "./preview-slidebar.vue?vue&type=template&id=8847b2fa&scoped=true&"
import script from "./preview-slidebar.vue?vue&type=script&lang=js&"
export * from "./preview-slidebar.vue?vue&type=script&lang=js&"
import style0 from "./preview-slidebar.vue?vue&type=style&index=0&id=8847b2fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8847b2fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
